import PropTypes from "prop-types";
/**
 * Created by fers on 25.07.16.
 */

import Relay from 'react-relay';

interface GrantAccessMutationProps {
  operation?: any;
  type?: any;
  args?: any;
  params?: any;
  channel_id?: any;
  scenario_id?: any;
  organisation_id?: any;
}

export default class GrantAccessMutation extends Relay.Mutation<GrantAccessMutationProps> {
  static propTypes = {
    operation: PropTypes.any,
    type: PropTypes.any,
    args: PropTypes.any,
    params: PropTypes.any,
    channel_id: PropTypes.any,
    scenario_id: PropTypes.any,
    organisation_id: PropTypes.any
  };
  getMutation() {
    return Relay.QL`mutation {grantAccess}`;
  }
  getVariables() {
    return {
      operation: this.props.operation,
      type: this.props.type,
      args: this.props.args,
      params: this.props.params,
      channel_id: this.props.channel_id,
      scenario_id: this.props.scenario_id,
      organisation_id: this.props.organisation_id
    };
  }
  getFatQuery() {
    return Relay.QL`
          fragment on GrantAccessPayload {
            url,
            redirectUrl,
            channel {
                        id,
                        realId,
                        organisation_id,
                        activated,
                        channelDef {
                            id,
                            name,
                            type,
                            authType,
                            metadata,
                            connectRequirement,
                            icon
                        },
                        type,
                        options,
                        authOptions,
                        name,
                        enabled,
                        currentUserOptions,
                    },
            result
          }
        `;
  }
  getConfigs() {
    return [{
      type: 'REQUIRED_CHILDREN',
      children: [this.getFatQuery()]
    }];
  }
}